import { Routes } from "@angular/router";
import { LoginPageComponent } from "./login-page.component";

export const loginPageRoutes: Routes = [
  {
    path: 'login',
    component: LoginPageComponent
  }
]
